module.exports = __webpack_public_path__ + "img/img18.ae985806.png";